var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIncident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164 10.4492V15.918C11.8164 16.2964 12.1216 16.6016 12.5 16.6016C12.8784 16.6016 13.1836 16.2964 13.1836 15.918V10.4492C13.1836 10.0708 12.8784 9.76562 12.5 9.76562C12.1216 9.76562 11.8164 10.0708 11.8164 10.4492Z",
    fill: "#DE3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8164 18.6523C11.8164 18.8336 11.8884 19.0075 12.0166 19.1357C12.1448 19.2639 12.3187 19.3359 12.5 19.3359C12.6813 19.3359 12.8552 19.2639 12.9834 19.1357C13.1116 19.0075 13.1836 18.8336 13.1836 18.6523C13.1836 18.471 13.1116 18.2972 12.9834 18.169C12.8552 18.0408 12.6813 17.9688 12.5 17.9688C12.3187 17.9688 12.1448 18.0408 12.0166 18.169C11.8884 18.2972 11.8164 18.471 11.8164 18.6523Z",
    fill: "#DE3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2574 20.1426L13.6578 3.5166C13.4015 3.07227 12.9498 2.84766 12.5006 2.84766C12.0514 2.84766 11.5997 3.06982 11.3434 3.5166L1.74375 20.1426C1.22861 21.0337 1.87314 22.147 2.90097 22.147H22.1002C23.128 22.147 23.7726 21.0337 23.2574 20.1426ZM2.92783 20.8262L12.5006 4.24658L22.1002 20.7798L2.92783 20.8262Z",
    fill: "#DE3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIncident);
export default __webpack_public_path__ + "static/media/warning-incident.f0ce62e1ed59a3b0519d4c6ff36b2d3b.svg";
export { ForwardRef as ReactComponent };